import {Map} from 'immutable';
import Passage from './Passage.react';

export default Map({
  renderer: Passage,
  type: 'passage',
  label: 'Passage'
});
